import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { ShipyardService } from "../../modules/shipyard/shipyard.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FormControl } from "@angular/forms";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-filter-dropdown",
  templateUrl: "./filter-dropdown.component.html",
  styleUrls: ["./filter-dropdown.component.scss"],
})
export class FilterDropdownComponent implements OnInit,OnDestroy {
  shipmentId = new FormControl("");
  containSkus = new FormControl("");
  shipmentType = new FormControl("");
  boxContents = new FormControl("");
  private filteredData: any;
  fbaTypes = this.shipyardService.getAllShipmentTypes();
  private destroy$ = new Subject<void>();


  constructor(
    private shipyardService: ShipyardService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<FilterDropdownComponent>,
  ) {}

  ngOnInit(): void {
    this.filteredData = this.data;
    this.shipmentId.setValue(this.filteredData?.shipmentId);
    this.containSkus.setValue(this.filteredData?.containSkus);
    this.shipmentType.setValue(this.filteredData?.shipmentType);
    this.boxContents.setValue(this.filteredData?.boxContents);
    this.dialogRef.backdropClick().pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.dialogRef.close("closed");
    });
  }

  searchShipment(event) {
    this.filteredData = {
      shipmentId: this.shipmentId.value,
      shipmentType:
        this.shipmentType.value === "All" ? undefined : this.shipmentType.value,
      containSkus: this.containSkus.value,
      boxContents: this.boxContents.value,
    };

    this.shipyardService.shipmentSearch$.next(this.filteredData);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
